module.exports = __webpack_public_path__ + "static/img/会见董事长.c1327455.jpg";